<template>

  <div class="rows">

    <div class="row" v-for="secteur in secteurs.data" v-bind:key="secteur.id">
      <div class="col-xs-5">
        <span class="title-item">Nom</span>
        <span class="text-item">{{secteur.nom}}</span>
      </div>
      <div class="col-xs-5">
        <span class="title-item">Arrondissement</span>
        <span class="text-item">
          {{ secteur.arrondissement_id |  arrondissementName }}
        </span>
      </div>
      <div class="col-xs-2">
        <div class="actions">
          <a class="action-edit" v-on:click="$emit('edit', secteur)">
            <img src="../../../../static/img/edit-icon.svg">
          </a>
          <a class="action-delete right-separator" v-on:click="$emit('delete', secteur)">
            <img src="../../../../static/img/delete-icon.svg">
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'secteurs',
    ]),
  },
  mounted: function () {
    this.$store.dispatch('fetchSecteursByVilleId')
  },
  methods: {
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// SecteursList.vue?5f20c070